import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import api from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import { PageHero, CTABand } from "@/components/Bits";

export default function CategoryPage() {
  const { slug } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    setData(null);
    api.get(`/categories/${slug}`).then((r) => setData(r.data)).catch(() => setData({ error: true }));
  }, [slug]);

  if (!data) return <div className="mx-auto max-w-[1400px] px-4 py-32 text-[#A1A1AA] lg:px-8">Carregando...</div>;
  if (data.error) return <div className="mx-auto max-w-[1400px] px-4 py-32 lg:px-8"><h1 className="font-heading text-2xl text-white">Categoria não encontrada</h1></div>;

  const { category, products } = data;
  return (
    <div>
      <PageHero eyebrow="Equipamentos" title={category.name} subtitle={category.description} image={category.image}>
        <div className="mt-6 flex items-center gap-1 text-xs text-[#A1A1AA]">
          <Link to="/equipamentos" className="hover:text-white">Equipamentos</Link>
          <ChevronRight className="h-3 w-3" /> <span className="text-white">{category.name}</span>
        </div>
      </PageHero>
      <div className="mx-auto max-w-[1400px] px-4 py-16 lg:px-8">
        {products.length === 0 ? (
          <p className="text-[#A1A1AA]">Modelos desta linha em desenvolvimento. Fale com nossa engenharia para um projeto sob medida.</p>
        ) : (
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {products.map((p) => <ProductCard key={p.slug} product={p} />)}
          </div>
        )}
      </div>
      <CTABand />
    </div>
  );
}
